import { useEffect } from "react";
import api from "../lib/api";

const setMeta = (attr, key, content) => {
    if (!content) return;
    let el = document.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

/**
 * useSeoMeta — busca /api/public/seo e injeta title, meta description,
 * keywords, Open Graph/Twitter tags e um bloco JSON-LD LocalBusiness no
 * <head>. Só para páginas públicas (landing, etc.) — nunca dentro do CRM.
 */
const useSeoMeta = () => {
    useEffect(() => {
        let alive = true;
        api.get("/public/seo")
            .then((seo) => {
                if (!alive || !seo) return;
                if (seo.title) document.title = seo.title;
                setMeta("name", "description", seo.meta_description);
                setMeta("name", "keywords", seo.keywords);
                setMeta("property", "og:type", "website");
                setMeta("property", "og:title", seo.og_title || seo.title);
                setMeta("property", "og:description", seo.og_description || seo.meta_description);
                setMeta("property", "og:image", seo.og_image);
                setMeta("property", "og:url", window.location.href);
                setMeta("name", "twitter:card", seo.twitter_card || "summary_large_image");
                setMeta("name", "twitter:title", seo.og_title || seo.title);
                setMeta("name", "twitter:description", seo.og_description || seo.meta_description);
                setMeta("name", "twitter:image", seo.og_image);

                const LD_ID = "seo-jsonld-localbusiness";
                let script = document.getElementById(LD_ID);
                if (!script) {
                    script = document.createElement("script");
                    script.id = LD_ID;
                    script.type = "application/ld+json";
                    document.head.appendChild(script);
                }
                script.textContent = JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "LocalBusiness",
                    name: seo.business_name || seo.title,
                    ...(seo.business_phone ? { telephone: seo.business_phone } : {}),
                    ...(seo.business_address ? { address: seo.business_address } : {}),
                    ...(seo.business_region ? { areaServed: seo.business_region } : {}),
                    ...(seo.google_review_link ? { sameAs: [seo.google_review_link] } : {}),
                    url: window.location.origin,
                });
            })
            .catch(() => { /* silencioso — SEO nunca deve travar a página */ });
        return () => { alive = false; };
    }, []);
};

export default useSeoMeta;
